/**
 * Put text in Ask Lilia's input without sending it.
 *
 * The page opens the dock on `lilia:ask-improve` and the panel fills its input
 * from the same event. When the dock was closed, the panel wasn't mounted to
 * hear it, and the text was lost; so the text also waits here until a panel
 * takes it, on mount or from the event.
 */
export const ASK_PREFILL_EVENT = "lilia:ask-improve";

let pending: string | null = null;

export function prefillAsk(message: string): void {
  if (!message.trim()) return;
  pending = message;
  window.dispatchEvent(new CustomEvent(ASK_PREFILL_EVENT, { detail: { message } }));
}

/** The text waiting for a panel, once. */
export function takeAskPrefill(): string | null {
  const m = pending;
  pending = null;
  return m;
}
